import { useQuery } from "@tanstack/react-query";
import { api } from "./client";

export function useSessions() {
  return useQuery({
    queryKey: ["sessions"],
    queryFn: () => api.listSessions(50),
    retry: 1,
    staleTime: 10000, // 10 seconds
  });
}

export function useWorklog(sessionId: string | null) {
  return useQuery({
    queryKey: ["worklog", sessionId],
    queryFn: () => api.getWorklog(sessionId!),
    enabled: !!sessionId,
  });
}

export function useArtifacts(sessionId: string | null) {
  return useQuery({
    queryKey: ["artifacts", sessionId],
    queryFn: () => api.listArtifacts(sessionId!),
    enabled: !!sessionId,
  });
}

export function useTenants() {
  return useQuery({
    queryKey: ["tenants"],
    queryFn: () => api.listTenants(),
  });
}

export function useSession(sessionId: string | null) {
  return useQuery({
    queryKey: ["session", sessionId],
    queryFn: () => api.getSession(sessionId!),
    enabled: !!sessionId,
  });
}

